import React, { Fragment } from 'react'
import SbEditable from 'storyblok-react'
import Img from 'gatsby-image'
import { getFixedGatsbyImage, getFluidGatsbyImage } from 'gatsby-storyblok-image'
import styled from 'styled-components'

import { Container } from '../.base/container'
import { DynamicComponent } from '../core'

const Article = styled.article`
  .article__intro,
  .article__author,
  .article__timeWrapper {
    opacity: 0.6;
  }

  .article__intro {
    font-size: 1.8rem;
    line-height: 1.7;
  }

  .article__avatar {
    display: block;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    overflow: hidden;
  }

  .article__banner {
    width: 680px;
    max-width: 100%;
    margin: 40px auto;
  }
`

const ArticleTemplate = ({ blok, tag_list }) => {
  const { author, title, intro, featured_image, published_at, body } = blok

  console.log(blok)

  const content =
    body &&
    body.map(childBlok => (
      <DynamicComponent blok={childBlok} key={childBlok._uid} />
    ))

  const formattedPublishedDate = new Date(published_at).toDateString()

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="App">
        <Container>
          <Article>
            {tag_list && tag_list.length > 0 ?
              <span className="gradient-text">
                {tag_list.map((tag, index) =>
                  <Fragment key={index}>{index !== 0 ? `, `: null}{tag}</Fragment>
                )}
              </span>
            : ''}
            <h2 className="u-h1 mb-4">{title}</h2>
            <p className="article__intro mb-4">{intro}</p>
            <hr />
            <div className="article__byline my-4 row align-center">
              {author.content ? (
                <div className="col-auto pr-0">
                  <span className="article__avatar">
                    <Img
                      fixed={getFixedGatsbyImage(
                        author.content.avatar_image.filename,
                        {
                          width: 35,
                          height: 35,
                        }
                      )}
                      alt={author.content.name}
                    />
                  </span>
                </div>
              ) : null}
              <small className="col">
                {author.content ? (
                  <address className="article__author mb-0">
                    By <span rel="author">{author.content.name}</span>
                  </address>
                ) : null}
                <span className="article__timeWrapper">
                  on{' '}
                  <time
                    pubdate="true"
                    dateTime={formattedPublishedDate}
                    title={formattedPublishedDate}
                  >
                    {formattedPublishedDate}
                  </time>
                </span>
              </small>
            </div>
            <div className="article__banner">
              <Img
                fluid={getFluidGatsbyImage(
                  featured_image[0].image.filename,
                  {
                    maxWidth: 680,
                  }
                )}
                alt={featured_image[0].image.alt}
              />
            </div>
            {content}
          </Article>
        </Container>
      </div>
    </SbEditable>
  )
}

export default ArticleTemplate